/** 站台識別（沿用現行 nagoya-cat.tw）。 */
export const SITE = {
  name: '下一次去名古屋吧！喵〜',
  tagline: '提供日本中部好吃又好玩的資訊',
  lang: 'zh-TW',
  locale: 'zh_TW',
  timezone: 'Asia/Taipei',
} as const;

/** 後台登入方式：限 LINE / Google（無 Yahoo）；邀請制，禁公開註冊。 */
export const OAUTH_PROVIDERS = ['line', 'google'] as const;
export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number];

export const ARTICLE_STATUSES = ['draft', 'in_review', 'scheduled', 'published'] as const;
export type ArticleStatus = (typeof ARTICLE_STATUSES)[number];

export const ARTICLE_KINDS = ['post', 'page'] as const;
export type ArticleKind = (typeof ARTICLE_KINDS)[number];
